import React, { Fragment } from 'react';
import { useEffect } from "react";
import PageTitle from "../../HOC/page-title";
import CardWrapper from "../../HOC/card/card";
import CardHeader from "../../components/card-header";
import "./assigned-details.scss";
import CustomButton from "../../components/custom-button";
import SectionTitle from "../../components/section-title";
import DetailsTable from "../../components/details-table";
import CustomizedSlider from "../../components/rating-phase";
import TextField from '@material-ui/core/TextField';
import { dataEOrg,dataECity,dataEProject,dataOrg,dataBank, dataProject,dataForAccountant,dataBankForAccountant,dataProjectForAccountant,dataOrgForApplicant,dataBankForApplicant,dataProjectForApplicant }  from "../../components/data";



let  finalData = dataOrg  ,finalDataBanking = dataBank  , FinalDataProject = dataProject  ;
const getData = () => {
  if (localStorage["type"] == 'accountant'){
    finalData = dataForAccountant;
    finalDataBanking = dataBankForAccountant;
    FinalDataProject = dataProjectForAccountant;
  }
  else if (localStorage["type"] == 'applicant'){
    finalData = dataOrgForApplicant;
    finalDataBanking = dataBankForApplicant;
    FinalDataProject = dataProjectForApplicant;
  }
  else if (localStorage["type"] == 'evalutor'){
    finalData = dataOrg;
    finalDataBanking = dataBank;
    FinalDataProject = dataProject;
  }
  else if (localStorage["type"] == 'ceo'){
    finalData = dataOrg;
    finalDataBanking = dataBank;
    FinalDataProject = dataProject;
  }
  else if (localStorage["type"] == 'chairman'){
    finalData = dataOrg;
    finalDataBanking = dataBank;
    FinalDataProject = dataProject;
  }
  else if (localStorage["type"] == 'superadmin'){
    finalData = dataOrg;
    finalDataBanking = dataBank;
    FinalDataProject = dataProject;
  }
  else {
    finalData = dataOrg;
    finalDataBanking = dataBank;
    FinalDataProject = dataProject;
  }
  
}


const ShowByTypeBtns = () => {
  if (localStorage["type"] == 'accountant') {
    return (
      <React.Fragment>
         <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="معلومات الجهة"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="المعلومات البنكية"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="معلومات المشروع"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="رفع الشيك"
              // handleClick={handleSave}
            />
      </React.Fragment>
    )
  }
  else if (localStorage["type"] == 'applicant') {
    return (
      <React.Fragment>
   
            <CustomButton
              styles={{ height: "45px", width:"250px" }}
              title="معلومات المشروع"
              // handleClick={handleSave}
            />
      </React.Fragment>
    )
  }
  else if (localStorage["type"] == 'evalutor') {
    return (
      <React.Fragment>
         <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="معلومات الجهة"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="المعلومات البنكية"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="معلومات المشروع"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="تقييم المشروع"
              // handleClick={handleSave}
            />
      </React.Fragment>
    )
   
  }
  else if (localStorage["type"] == 'ceo') {
    return (
      <React.Fragment>
         <CustomButton
              styles={{ height: "45px", width:"250px" }}
              title="معلومات الجهة"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"250px" }}
              title="المعلومات البنكية"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"250px" }}
              title="معلومات المشروع"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="كتابة التوصية"
              // handleClick={handleSave}
            />
      </React.Fragment>
    )
   
  }
  else if (localStorage["type"] == 'chairman') {
    return (
      <React.Fragment>
         <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="معلومات الجهة"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="المعلومات البنكية"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="معلومات المشروع"
              // handleClick={handleSave}
            />
            
            <CustomButton
            styles={{ height: "45px", width:"200px" }}
            title=" طباعة الطلب"
            // handleClick={handleSave}
          />
      </React.Fragment>
    )
  }
  else if (localStorage["type"] == 'superadmin') {
    return (
      <React.Fragment>
         <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="معلومات الجهة"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="المعلومات البنكية"
              // handleClick={handleSave}
            />
            <CustomButton
              styles={{ height: "45px", width:"200px" }}
              title="معلومات المشروع"
              // handleClick={handleSave}
            />
            
            <CustomButton
            styles={{ height: "45px", width:"200px" }}
            title=" طباعة الطلب"
            // handleClick={handleSave}
          />
      </React.Fragment>
    )
  }
  else {
  }

}

const ShowByTypeInfo = () => {
  if (localStorage["type"] == 'accountant') {
    return(
      <React.Fragment>
            <CardWrapper classes="header-fixed">
            <CardHeader title="تفاصيل طلب الجهة">
              <div className="buttons-container">
                {ShowByTypeBtns()}
              </div>
            </CardHeader>
        
            <SectionTitle title="معلومات الجهة" />
            <DetailsTable data={finalData} />
          </CardWrapper>
        
          <CardWrapper>
            <SectionTitle title="المعلومات البنكية" />
            <DetailsTable data={finalDataBanking} />
          </CardWrapper>
        
        
          <CardWrapper>
            <SectionTitle title="معلومات المشروع" />
            <DetailsTable data={FinalDataProject} />
          </CardWrapper>
      </React.Fragment>
    )
}
else if (localStorage["type"] == 'applicant') {
  return(
    <React.Fragment>
          <CardWrapper classes="header-fixed">
          <CardHeader title="تفاصيل طلب الجهة">
            <div className="buttons-container">
              {ShowByTypeBtns()}
            </div>
          </CardHeader>
          <SectionTitle title="معلومات المشروع" />
          <DetailsTable data={FinalDataProject} />
         
        </CardWrapper>
      
      
      
     
    </React.Fragment>
  )
}
else if (localStorage["type"] == 'evalutor') {
  return(
    <React.Fragment>
          <CardWrapper classes="header-fixed">
          <CardHeader title="تفاصيل طلب الجهة">
            <div className="buttons-container">
              {ShowByTypeBtns()}
            </div>
          </CardHeader>
      
          <SectionTitle title="معلومات الجهة" />
          <DetailsTable data={finalData} />
        </CardWrapper>
      
        <CardWrapper>
          <SectionTitle title="المعلومات البنكية" />
          <DetailsTable data={finalDataBanking} />
        </CardWrapper>
      
      
        <CardWrapper>
          <SectionTitle title="معلومات المشروع" />
          <DetailsTable data={FinalDataProject} />
        </CardWrapper>
    </React.Fragment>
  )
 
}
else if (localStorage["type"] == 'ceo') {
  return(
    <React.Fragment>
          <CardWrapper classes="header-fixed">
          <CardHeader title="تفاصيل طلب الجهة">
            <div className="buttons-container">
              {ShowByTypeBtns()}
            </div>
          </CardHeader>
      
          <SectionTitle title="معلومات الجهة" />
          <DetailsTable data={finalData} />
        </CardWrapper>
      
        <CardWrapper>
          <SectionTitle title="المعلومات البنكية" />
          <DetailsTable data={finalDataBanking} />
        </CardWrapper>
      
      
        <CardWrapper>
          <SectionTitle title="معلومات المشروع" />
          <DetailsTable data={FinalDataProject} />
        </CardWrapper>
    </React.Fragment>
  )
}
else if (localStorage["type"] == 'chairman') {
  return(
    <React.Fragment>
          <CardWrapper classes="header-fixed">
          <CardHeader title="تفاصيل طلب الجهة">
            <div className="buttons-container">
              {ShowByTypeBtns()}
            </div>
          </CardHeader>
      
          <SectionTitle title="معلومات الجهة" />
          <DetailsTable data={finalData} />
        </CardWrapper>
      
        <CardWrapper>
          <SectionTitle title="المعلومات البنكية" />
          <DetailsTable data={finalDataBanking} />
        </CardWrapper>
      
      
        <CardWrapper>
          <SectionTitle title="معلومات المشروع" />
          <DetailsTable data={FinalDataProject} />
        </CardWrapper>
    </React.Fragment>
  )
}
else if (localStorage["type"] == 'superadmin') {
  return(
    <React.Fragment>
          <CardWrapper classes="header-fixed">
          <CardHeader title="تفاصيل طلب الجهة">
            <div className="buttons-container">
              {ShowByTypeBtns()}
            </div>
          </CardHeader>
      
          <SectionTitle title="معلومات الجهة" />
          <DetailsTable data={finalData} />
        </CardWrapper>
      
        <CardWrapper>
          <SectionTitle title="المعلومات البنكية" />
          <DetailsTable data={finalDataBanking} />
        </CardWrapper>
      
      
        <CardWrapper>
          <SectionTitle title="معلومات المشروع" />
          <DetailsTable data={FinalDataProject} />
        </CardWrapper>
    </React.Fragment>
  )
}
else {
 
}

  
}


const ShowByTypeInfoShawi = () => {
  if (localStorage["type"] == 'accountant') {
      return(
        <React.Fragment>
            <CardWrapper>
                <SectionTitle title="معلومات المؤسسة عن الجهة " />
                <div className="info-about">
                <div className="info-about-proj">
                      <h3>
                        عدد مرات دعم الجهة 
                      </h3>
                      <p>2</p>
                    </div>    
                </div>
                
          </CardWrapper>
        </React.Fragment>
      )
  }
  else if (localStorage["type"] == 'applicant') {
  
  }
  else if (localStorage["type"] == 'evalutor') {
    return(
      <React.Fragment>
          <CardWrapper>
              <SectionTitle title="معلومات المؤسسة عن الجهة " />
              <div className="info-about">
              <div className="info-about-proj">
                    <h3>
                      عدد مرات دعم الجهة 
                    </h3>
                    <p>2</p>
                  </div>

                  <div className="info-about-proj-org">
                    <h3>
                      متوسط تقييم الجهة 
                    </h3>
                    <p>4</p>
                  </div>
              
              </div>
              
        </CardWrapper>
      </React.Fragment>
    )
   
  }
  else if (localStorage["type"] == 'ceo') {
    return(
      <React.Fragment>
          <CardWrapper>
              <SectionTitle title="معلومات المؤسسة عن الجهة " />
              <div className="info-about">
              <div className="info-about-proj">
                    <h3>
                      عدد مرات دعم الجهة 
                    </h3>
                    <p>2</p>
                  </div>

                  <div className="info-about-proj-org">
                    <h3>
                      متوسط تقييم الجهة 
                    </h3>
                    <p>4</p>
                  </div>
              
              </div>
              
        </CardWrapper>
      </React.Fragment>
    )
  }
  else if (localStorage["type"] == 'chairman') {
    return(
      <React.Fragment>
          <CardWrapper>
              <SectionTitle title="معلومات المؤسسة عن الجهة " />
              <div className="info-about">
              <div className="info-about-proj">
                    <h3>
                      عدد مرات دعم الجهة 
                    </h3>
                    <p>2</p>
                  </div>

                  <div className="info-about-proj-org">
                    <h3>
                      متوسط تقييم الجهة 
                    </h3>
                    <p>4</p>
                  </div>
              
              </div>
              
        </CardWrapper>
      </React.Fragment>
    )
  }
  else if (localStorage["type"] == 'superadmin') {
    return(
      <React.Fragment>
          <CardWrapper>
              <SectionTitle title="معلومات المؤسسة عن الجهة " />
              <div className="info-about">
              <div className="info-about-proj">
                    <h3>
                      عدد مرات دعم الجهة 
                    </h3>
                    <p>2</p>
                  </div>

                  <div className="info-about-proj-org">
                    <h3>
                      متوسط تقييم الجهة 
                    </h3>
                    <p>4</p>
                  </div>
              
              </div>
              
        </CardWrapper>
      </React.Fragment>
    )
  }
  else {
    
  }

}


const ShowByTypeEvaluationActions = () => {
  if (localStorage["type"] == 'accountant') {
    return(
      <React.Fragment>
      <CardWrapper>
            <SectionTitle title="توثيق الطلب ورفع الشيك" />
            <div className="student-recommendition">
                  <div>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      id="paymentcheque"
                      label="صورة الشيك"
                      name="paymentcheque"
                      type="file"
                      
                    />
                  </div>
                  
                  <div className="actions-container">
                  <CustomButton
                    title="إتمام التوثيق"
                    classes="accepting"
                    // handleClick={handleSave}
                  />
               
                </div>
                 

          </div>
      </CardWrapper>
      </React.Fragment>
    )
  }
  else if (localStorage["type"] == 'applicant') {
  
  }
  else if (localStorage["type"] == 'evalutor') {
    return(
      <React.Fragment>

            <CardWrapper classes="header-fixed">
            <CardHeader title=" تقييم الطلب بناء على معايير الدعم ">
            </CardHeader>
            <SectionTitle title="معايير متعلقة بالجهة " />
            <div className="actions1">
                <CustomizedSlider ratingSliderTitle ={"احتياج الجهة للدعم"} value={25}/>
                <CustomizedSlider ratingSliderTitle ={"جهة موثوقة وذات مصداقية"} value={25}/>
                <CustomizedSlider ratingSliderTitle ={"ذات مهنية ومؤسسية"} value={25}/>
            </div>

            <SectionTitle title="معايير متعلقة بالمنطقة " />
            <div className="actions1">
                <CustomizedSlider ratingSliderTitle ={"حاجة المنطقة للجهات الخيرية "} value={50}/>
                <CustomizedSlider ratingSliderTitle ={"وجود انحرافات عقدية وفكرية"} value={50}/>
                <CustomizedSlider ratingSliderTitle ={"استراتيجية المنطقة"} value={50}/>
                <CustomizedSlider ratingSliderTitle ={"قلة الداعمين أو انعدامهم في المنطقة"} value={50}/>
                <CustomizedSlider ratingSliderTitle ={"مستوى نضج العمل الخيري"} value={50}/>
            </div>

            <SectionTitle title="معايير متعلقة بالمشروع " />
            <div className="actions1">
                <CustomizedSlider ratingSliderTitle ={"ذو أولوية وحاجة "} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"ذو بعد تنموي"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"موافق وضمن نشاط الجهة"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"تكامل خطة وعمليات المشروع"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"تميز المشروع"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"موافق لاستراتيجية المؤسسة"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"وجود بعد الاستدامة"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"وضوح الأهداف"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"أثر وبصمة المشروع"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"إمكانية التنفيذ"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"عدد المستفيدين"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"فئة المستفيدين"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"اتساع نطاق المشروع"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"مدير المشروع"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"وجود شريك متميز ومتخصص"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"واقعية الميزانية"} value={75}/>
                <CustomizedSlider ratingSliderTitle ={"يعتبر مشروع دائم في الجهة"} value={75}/>
            </div>
            </CardWrapper>

            <CardWrapper>
            <SectionTitle title="المبلغ المقترح للمشروع" />
            <div className="student-recommendition-budget">
                  <div>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      id="payment"
                      label="المبلغ المقترح  "
                      name="payment"
                      type="number"
                    />
                  </div>

          </div>
      </CardWrapper>

            <CardWrapper>
              <SectionTitle title="توصية الدارس" />
              <div className="student-recommendition">
                    <div>
                      <TextField
                      variant="outlined"
                                  margin="normal"
                                  multiline
                                  fullWidth
                                  id="message"
                                  rows={16}
                                  label="كتابة التوصية  "
                                  name="message"
                                  type="message"
                      />
                    </div>
                    <div className="actions-container">
                      <CustomButton
                        title="قبول الطلب"
                        classes="accepting"
                        // handleClick={handleSave}
                      />
                      <CustomButton
                        title="رفض الطلب"
                        classes="reject"
                        // handleClick={handleSave}
                      />
                    </div>
            </div>
        </CardWrapper>
      </React.Fragment>
    )
   
  }
  else if (localStorage["type"] == 'ceo') {

    return(
      <React.Fragment>
         

      <CardWrapper>
        <SectionTitle title="معايير متعلقة بالجهة" />
        <DetailsTable data={dataEOrg} />
      </CardWrapper>

      <CardWrapper>
        <SectionTitle title="معايير متعلقة بالمنطقة" />
        <DetailsTable data={dataECity} />
      </CardWrapper>

      <CardWrapper>
        <SectionTitle title="معايير متعلقة بالمشروع" />
        <DetailsTable data={dataEProject} />
      </CardWrapper>
            <CardWrapper>
            <SectionTitle title="توصية الدارس" />
            <div className="student-recommendition">
                  <div>
                      <p> هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.            </p>
                  </div>        
          </div>

          <div className="student-recommendition-budget-d">
          <SectionTitle title="المبلغ المقترح من الدارس" />
              <div>
                   <p>60000 ريال</p>
              </div>
          </div>
      </CardWrapper>

      <CardWrapper>
      <SectionTitle title="توصية المدير التنفيذي " />
      <div className="student-recommendition">
            <div>
              <TextField
              variant="outlined"
                          margin="normal"
                          multiline
                          fullWidth
                          id="message"
                          rows={16}
                          label="كتابة التوصية  "
                          name="message"
                          type="message"
              />
            </div>
            <div className="actions-container">
              <CustomButton
                title="قبول الطلب"
                classes="accepting"
                // handleClick={handleSave}
              />
              <CustomButton
                title="مناقشة الطلب"
                classes="discussing"
                // handleClick={handleSave}
              />
            </div>
    </div>
</CardWrapper>
      </React.Fragment>
    )
   
    
  }
  else if (localStorage["type"] == 'chairman') {
    return(
      <React.Fragment>
          <CardWrapper>
            <SectionTitle title="معايير متعلقة بالجهة" />
            <DetailsTable data={dataEOrg} />
          </CardWrapper>

          <CardWrapper>
            <SectionTitle title="معايير متعلقة بالمنطقة" />
            <DetailsTable data={dataECity} />
          </CardWrapper>

          <CardWrapper>
            <SectionTitle title="معايير متعلقة بالمشروع" />
            <DetailsTable data={dataEProject} />
          </CardWrapper>
        <CardWrapper>
            <SectionTitle title="توصية الدارس" />
            <div className="student-recommendition">
                  <div>
                      <p> هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.            </p>
                  </div>

                  <SectionTitle title="توصية المدير التنفيذي" /> 
                    <div>
                        <p> هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.            </p>
                    </div>
                  <div className="actions-container">
                    <CustomButton
                      title="قبول الطلب"
                      classes="accepting"
                      // handleClick={handleSave}
                    />
                    <CustomButton
                    title="مناقشة الطلب"
                    classes="discussing"
                    // handleClick={handleSave}
                  />
                    <CustomButton
                      title="رفض الطلب"
                      classes="reject"
                      // handleClick={handleSave}
                    />
                  </div>
          </div>
      </CardWrapper>
      </React.Fragment>
    )
  }
  else if (localStorage["type"] == 'superadmin') {
    return(
      <React.Fragment>
          <CardWrapper>
            <SectionTitle title="معايير متعلقة بالجهة" />
            <DetailsTable data={dataEOrg} />
          </CardWrapper>

          <CardWrapper>
            <SectionTitle title="معايير متعلقة بالمنطقة" />
            <DetailsTable data={dataECity} />
          </CardWrapper>

          <CardWrapper>
            <SectionTitle title="معايير متعلقة بالمشروع" />
            <DetailsTable data={dataEProject} />
          </CardWrapper>
        <CardWrapper>
            <SectionTitle title="توصية الدارس" />
            <div className="student-recommendition">
                  <div>
                      <p> هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.            </p>
                  </div>

                  <SectionTitle title="توصية المدير التنفيذي" /> 
                    <div>
                        <p> هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.            </p>
                    </div>

                    <SectionTitle title="رئيس مجلس الأمناء" /> 
                    <div>
                        <p>تتم مناقشة الطلب </p>
                    </div>
                
          </div>
      </CardWrapper>
      </React.Fragment>
    )
  }
  else {
  
  }

}


const AssignedDetails = ({ handleChangeKey }) => {
  useEffect(() => {
    handleChangeKey(3);
  }, []);
  console.log("Tst");
  getData();
  return (
    <div className="assigned-details-container">

      {ShowByTypeInfo()}

      {ShowByTypeInfoShawi()}
  
      {ShowByTypeEvaluationActions()}

    </div>
  );
};

export default PageTitle(AssignedDetails);
